import {override} from 'mobx';
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {RedirectModel} from "./redirect-model";

export class TodayRedirectModel extends RedirectModel {
  name: String;
  cultureName: String;

  constructor(name: String, cultureName: String, datetimeUtils: DatetimeUtils) {
    super(name, cultureName);

    this.datetimeUtils = datetimeUtils;
  }

  @override get from() {
    const today: Date = new Date();
    const urlDate = this.datetimeUtils.toURLDate(today.midnight())

    return `${this.languageDisplayName}/:sportName/${urlDate}`;
  }

  @override get to() {
    return `${this.languageDisplayName}/:sportName`;
  }
}